import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Navbar from "../components/navigation/Navbar";
import AuthenticatedNavbar from "../components/AuthenticatedNavbar";
import Hero from "../components/Landing/Hero";
import DealsShowcase from "../components/Landing/DealsShowcase";
import CTA from "../components/Landing/CTA";
import Footer from "../components/Landing/Footer";
import { toast } from "react-toastify";
import dealsService from "../components/services/DealsService";
import Loader from "../components/Loader";
import ProductMarketplaceBanner from "../components/Landing/ProductMarketplaceBanner";
import PromotionalBanner from "../components/Landing/PromotionalBanner";
const Landing = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [trendingDeals, setTrendingDeals] = useState([]);
  const [fashionDeals, setFashionDeals] = useState([]);
  const { isAuthenticated, isVerified, user } = useSelector((state) => state.auth);

  useEffect(() => {
    const fetchTrendingDeals = async () => {
      setIsLoading(true);
      try {
        const [response, fashionResponse] = await Promise.all([
          dealsService.getTrendingDeals(),
          dealsService.getFashionDeals(),
        ]);
        if (response?.data?.status_code === "000") {
          setTrendingDeals(response?.data?.data);
        } else {
          toast.error(response?.data?.reason || "Something went wrong");
        }
        if (fashionResponse?.data?.status_code === "000") {
          setFashionDeals(fashionResponse?.data?.data);
        } else {
          toast.error(fashionResponse?.data?.reason || "Something went wrong");
        }
      } catch (error) {
        toast.error(error?.response?.data?.reason || "Something went wrong");
      } finally {
        setIsLoading(false);
      }
    };
    fetchTrendingDeals();
  }, []);

  if (isLoading) {
    return <Loader />;
  }
  return (
    <div className="Landing">
      {isAuthenticated && isVerified ? <AuthenticatedNavbar /> : <Navbar />}
      <Hero isAuthenticated={isAuthenticated && isVerified} user={user} />
      <ProductMarketplaceBanner />
      <DealsShowcase 
        type={"trending"} 
        trendingDeals={trendingDeals} 
        isAuthenticated={isAuthenticated && isVerified}
      />
      <PromotionalBanner />
      <DealsShowcase 
        type={"fashion"} 
        trendingDeals={fashionDeals} 
        isAuthenticated={isAuthenticated && isVerified}
      />
      {/* cta shows only when not authenticated */}
      {!isAuthenticated && <CTA />}
      {/* <CTA /> */}
      <Footer />
    </div>
  );
};

export default Landing;
